






























import {Vue, Component, Prop} from 'vue-property-decorator';
import WipQiDetails from "@/domainObjects/wip/WipQiDetails";
import WipTicket from "@/domainObjects/wip/WipTicket";
import QiDetailForm from "@/view/shared-components/QiDetailForm.vue";

@Component({
    components: {QiDetailForm}
})

export default class WipQiDetailsForm extends Vue {
    @Prop({required: true}) wipTicket!: WipTicket;
    @Prop({required: true}) type!: String;

    qiHoldDetails:WipQiDetails;

    constructor(){
        super();
        this.qiHoldDetails = new WipQiDetails();
    }

    add(){
        this.wipTicket.qiHoldDetails.unshift(this.qiHoldDetails);
        this.qiHoldDetails = new WipQiDetails();
        for (let i = 0; i < this.wipTicket.qiHoldDetails.length; i++){
            this.wipTicket.qiHoldDetails[i].wipTicketId = this.wipTicket.wipTicketId;
        }
    }

    remove(i){
        this.wipTicket.qiHoldDetails.splice(i, 1);
        if (this.wipTicket.qiHoldDetails.length === 0){
            this.add()
        }
    }

}

